import { theme as designSystemTheme } from '@openx/design-system';

export const WEIGHT_LIGHT = designSystemTheme.typography.fontWeightLight;
export const WEIGHT_NORMAL = designSystemTheme.typography.fontWeightRegular;
export const WEIGHT_MEDIUM = designSystemTheme.typography.fontWeightMedium;
export const WEIGHT_BOLD = designSystemTheme.typography.fontWeightBold;

export const WEIGHT_EXTRABOLD = 800;

// Design System typography (Figtree). subtitle1, subtitle2 and h4–h6 are not styled by the DS
// and intentionally fall back to MUI defaults.
export const typography = designSystemTheme.typography;
